import { Box, List, ListSubheader, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";
import { NavSectionProps } from "layouts/type";
import { NavListRoot } from "./NavList";

export const ListSubheaderStyle = styled((props) => (
  <ListSubheader disableSticky disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.overline,
  paddingTop: theme.spacing(0),
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  color: theme.palette.text.primary,
  transition: theme.transitions.create("opacity", {
    duration: theme.transitions.duration.shorter,
  }),
}));

export default function NavSectionVertical({
  navConfig,
  isCollapse = false,
  ...other
}: NavSectionProps) {
  return (
    <>
      <Divider
        variant="middle"
        sx={{ marginTop: "8px !important", minWidth: "52px" }}
      />{" "}
      <Box {...other}>
        {navConfig.map((group, index) => (
          <List key={index} disablePadding>
            {group.items.map((list, i) => (
              <NavListRoot
                key={list.title + "_" + list.path + "_" + i}
                list={list}
                isCollapse={isCollapse}
              />
            ))}
          </List>
        ))}
      </Box>
    </>
  );
}
